import logoWhite from "../assets/jauja-logo-white.png";
import logoGray from "../assets/jauja-logo-gray.png";

// Official "logo_jauja_2026" asset. Green dots are baked into the image.
// White-text version for dark backgrounds; gray-text version for light backgrounds.
const ASPECT = 2.283; // width / height of the processed logo image

export const Logo = ({ height = 32, dark = false, className = "" }) => {
  const width = height * ASPECT;
  return (
    <img
      src={dark ? logoGray : logoWhite}
      alt="Jauja Consultores"
      className={`inline-block ${className}`}
      style={{ height: `${height}px`, width: `${width}px`, display: "block" }}
      data-testid="jauja-logo"
    />
  );
};

export default Logo;
